import { Status } from '../status/status';
import { Attachment } from '../attachment/attachment';

export class Activity {
  Id?: number;
  FaultId?: number;
  Status?: Status;
  Description: string;
  Date?: Date;
  DueDate?: Date;
  ReplyUntil?: Date;
  SyncId?: string;
  IsFirst?: boolean;
  IsLast?: boolean;
  IsLastOfViewPoint?: boolean;
  ViewPoint?: number;
  SUid?: string;
  Files?: Attachment[]
}
